const toQueryParams = <T extends Record<string, string | number>>(obj: T) =>
  Object.keys(obj)
    .filter((k) => obj[k])
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
    .join('&');

export default toQueryParams;
